import React from "react";
import { StyledDiv } from "../../../styled";

const AuthorDescription = () => (
    <StyledDiv>
        Hej 😊 <br /><br />
        <p>
            Jestem początkującą <b>frontend - developerką</b>.
        </p>
        <p>
            Kodowanie to moja pasja i nie potrafię się oderwać od ekranu, kiedy tworzę coś nowego i ciekawego.
        </p>
        <p>
            Kiedy potrzebuję odpoczynku, zanurzam się w świecie gier komputerowych.
            Lubię też aktywnie spędzać czas na świeżym powietrzu, zwłaszcza w górach, gdzie mogę zmierzyć się z własnymi słabościami.
            W tym roku udało mi się przejść całe Karkonosze zimą w trudnych warunkach pogodowych co jest dla mnie dużym osiągnięciem 🎉 </p>
        <p>
            Już planuję kolejne podróże i wyprawy, które będą niezapomnianymi doświadczeniami! 💪
        </p>
    </StyledDiv>

);

export default AuthorDescription;